import { withWebAssetsTheme } from '../../theme';
import { withClientErrorPage } from '../ClientError';
import FourHundredError from './FourHundredError';
export default withWebAssetsTheme(withClientErrorPage(FourHundredError, {
  titularElementTag: 'h1',
  // set default to H1
  errorCode: 400
}));
//# sourceMappingURL=FourHundredErrorPage.js.map